import { usePortalOverview } from '../api';
import { PageError, PageSkeleton } from '../frame/PageState';
import frame from '../frame/Portal.module.css';
import { OverviewContent } from './OverviewContent';

/** `/portal/:orgSlug` — Mandantenportal 14–17 / 15 (`GET /api/portal/overview`). */
export function OverviewPage() {
  const overview = usePortalOverview();
  if (overview.isPending) return <PageSkeleton blocks={[260, 220, 240]} />;
  if (overview.isError) {
    return (
      <div className={frame.content}>
        <PageError
          what="Die Übersicht"
          error={overview.error}
          onRetry={() => void overview.refetch()}
          retrying={overview.isFetching}
        />
      </div>
    );
  }
  return (
    <div className={frame.content}>
      <OverviewContent data={overview.data} />
    </div>
  );
}
